const energyEfficientWindows = [
  {
    question: "What are energy-efficient windows?",
    answer:
      "Energy-efficient windows<IN_CITY_ZIP> are designed to reduce heat transfer, keeping your home warmer in the winter and cooler in the summer. They use low-E coatings, insulated frames, and multi-pane glass to improve indoor comfort and lower energy bills.",
  },
  {
    question: "How much can I save on energy bills with new windows?",
    answer:
      "Homeowners<IN_CITY_ZIP> typically save 10% to 15% on energy costs after upgrading to energy-efficient windows. The actual savings depend on the number of windows replaced, your insulation, and how much heating or cooling your home requires.",
  },
  {
    question: "Do I need a permit to replace my windows?",
    answer:
      "Yes — in most cities<IN_CITY_ZIP>, a permit is required if the replacement changes the size or structure of the window opening. Modern Build handles all necessary permitting to ensure your project stays compliant.",
  },
  {
    question: "How long does it take to install new windows?",
    answer:
      "Most window installation projects<IN_CITY_ZIP> are completed in 1 to 3 days, depending on the number of windows, framing conditions, and custom sizing. We'll provide an accurate timeline during your free consultation.",
  },
  {
    question: "What types of energy-efficient windows do you offer?",
    answer:
      "We install double-pane and triple-pane windows<IN_CITY_ZIP> with low-E glass, argon or krypton gas fills, and UV protection. Frame options include vinyl, fiberglass, and composite, each designed for energy savings and durability.",
  },
  {
    question: "Can new windows reduce outside noise?",
    answer:
      "Yes. Multi-pane windows<IN_CITY_ZIP> with insulated glass and tight seals significantly reduce outside noise — ideal for homes near busy streets, airports, or schools.",
  },
  {
    question: "Are your windows ENERGY STAR® certified?",
    answer:
      "Yes. All of our window options<IN_CITY_ZIP> meet or exceed ENERGY STAR® standards for energy efficiency. You may also qualify for local rebates or federal tax credits depending on the program in your area.",
  },
  {
    question: "How much do energy-efficient windows cost?",
    answer:
      "Prices vary based on size, frame material, and energy features. Most energy-efficient window installations<IN_CITY_ZIP> range from $700 to $1,200 per window. We provide detailed quotes during your free estimate.",
  },
  {
    question: "Do energy-efficient windows increase home value?",
    answer:
      "Yes. Installing energy-efficient windows<IN_CITY_ZIP> improves curb appeal, lowers utility bills, and makes your home more attractive to buyers. It’s one of the highest-ROI upgrades you can make to your property.",
  },
];

export default energyEfficientWindows;
